/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Попап заказа услуги
   */
  app.ServiceOrderFormView = app.FormView.extend({
    events: {
      'click .js-send-order': 'sendOrder',
      'click [data-item-inc]': 'increaseQty',
      'click [data-item-dec]': 'decreaseQty',
      'keyup .js-qty-input': 'inputValidation',
      'click .fav-add': 'toggleInWishes',
      'change .js-accept-agreement': 'deleteAgreementValidationMessage',
    },

    formName: 'service-order-form',
    formElement: '.js-validated',

    run: function () {
      this.template = app.helpers.TemplateHelper.getTemplate('#service-order-form-template');
      this.templateTotal = app.helpers.TemplateHelper.getTemplate('#service-order-popup-total-template');
      this.templateItem = app.helpers.TemplateHelper.getTemplate('#service-order-popup-item-template');
      this.templateBankForm = app.helpers.TemplateHelper.getTemplate('#pay-form-template');
      this.templateAgreement = app.helpers.TemplateHelper.getTemplate('#service-order-popup-agreement');

      this.isToggleWishProcess = false;

      this.model = new app.Order(null, { requestParameters: { features: 'accept_agreement' } });
      this.user = new app.User(app.userJson);

      this.render();
      this.childViews.phoneInputmaskView = new app.PhoneInputmaskView({'el': this.$('.input-phone')});
      this.childViews.choiceCountryView = new app.ChoiceCountryView({'el': this.$('.choice-country')});
      this.button = this.$('.js-send-order');
    },

    /**
     * Обновить модель товара
     * @param item app.Item
     */
    updateItem: function (item) {
      if (item instanceof app.Item){
        this.item = item;
        if (!this.item.get('qty')){
          this.item.set('qty', 0);
        }

        this.renderItem();
        this.renderAgreement();
        this.updateQty();
      }
    },
    /**
     * Стираем ошибку валидации условий использования сертификатов
     */
    deleteAgreementValidationMessage: function () {
      var isRulesAccepted = this.$('.js-accept-agreement').prop('checked');
      if (isRulesAccepted) {
        this.$('.agreement-error-message').html('');
      }
    },

    /**
     * Рендерим форму, обновляем список полей для отправки
     */
    render: function () {
      this.$el.html(this.template({
        user: this.user,
        isMobile: app.isMobile,
      }));
      this.updateFieldsList();
    },

    /**
     * Нарисовать товар
     */
    renderItem: function () {
      this.$('.js-item-block').html(this.templateItem({
        item: this.item.toJSON(),
        price: app.helpers.NumberHelper.fractionPrice(this.item.get('price')),
        getPhotoUrl: this.item.getPhotoUrl.bind(this.item)
      }));
      if (this.item.get('wish_item')) {
        this.$('.flag_icon').removeClass('ctl-hidden with-icon_favs-grey').addClass('with-icon_favs-red');
      }
    },
    /**
     * Нарисовать ссылку на условия покупки
     */
    renderAgreement: function () {
      this.$('.js-agreement').html(this.templateAgreement());
    },
    /**
     * Валидация поля
     * @param event
     */
    inputValidation: function (event) {
      var qty = parseInt(event.target.value, 10);
      if (_.isNaN(qty)) {
        event.target.value = '0';
        this.item.set('qty', 0);
        this.updateQty();
      } else {
        event.target.value = event.target.value.replace(/([^0-9])/g, '');
        if (event.keyCode === app.KEY_CODES.Enter) {
          this.ieFix();
        }
        if (qty !== this.item.get('qty')) {
          this.item.set('qty', qty);
          this.updateQty();
        }
        if (qty >= this.item.get('max_qty')) {
          this.item.set('qty', this.item.get('max_qty'));
          this.updateQty();
        }
      }
    },
    /**
     * Обновить количество товара и сумму заказа в разметке
     */
    updateQty: function () {
      var qty = this.item.get('qty');
      var price = this.item.get('price');

      this.$('.js-qty-input').val(qty);
      this.$('.js-total').html(this.templateTotal({
        total: app.helpers.NumberHelper.fractionPrice(qty * price),
        currencySign: this.item.get('currencySign')
      }));
      if ((qty * price) === 0) {
        this.button.attr('disabled', true);
      } else {
        this.button.attr('disabled', false);
      }
    },

    /**
     * Отправить заказ-услугу
     * @param e
     */
    sendOrder: function (e) {
      e.preventDefault();
      this.button.attr('disabled', true);
      var that = this;
      var data = this.getData();
      var isRulesAccepted = this.$('.js-accept-agreement').prop('checked');

      data.isAcceptAgreement = isRulesAccepted ? 'on' : 'off';
      data.item_id = this.item.get('id');
      data.qty = this.item.get('qty');
      data.type = 'service-order';

      this.model.save(data, {
        success: this.proceedPayment.bind(this),
        error: function () {
          that.error.apply(that, arguments);
          that.button.attr('disabled', false);
        }
      });
    },
    /**
     * Увеличить количество
     */
    increaseQty: function () {
      var prevQty = this.item.get('qty');
      this.item.set('qty', prevQty + 1);
      this.updateQty();
    },

    /**
     * Уменьшить количество
     */
    decreaseQty: function () {
      var prevQty = this.item.get('qty');
      if (prevQty > 0){
        this.item.set('qty', prevQty - 1);
      }
      this.updateQty();
    },

    /**
     * Создаем форму и отправляем ее в банк для оплаты
     */
    proceedPayment: function () {
      var data = this.model.get('payment_form_data');
      if (data.method === 'POST') {
        this.$('.js-bank-form-block')
          .html(this.templateBankForm({data: data.data}))
          .find('form')
          .submit();
      } else {
        app.helpers.RedirectHelper.locationAssign(data.url);
      }
    },
    /**
     * Добавление / удаление услуги из избранного
     */
    toggleInWishes: function () {
      var id = this.item.get('id'),
          that = this;

      if (this.isToggleWishProcess) {
        return;
      }
      this.isToggleWishProcess = true;

      if (!this.item.get('wish_item') && !app.wish.get(id)) {
        this.isWishItem = false;
      } else {
        this.isWishItem = true;
        if (app.isMobile) {
          var wishItemData = this.item.get('wish_item');
          this.wishItem = new app.WishItem(wishItemData);
          app.wish.add(this.wishItem, { silent: true });
        }
      }

      if (!app.user.id) {
        this.redirectToAuth();
        return;
      }

      if (this.isWishItem) {
        app.wish.deleteByItemsIds([id]);
        this.item.set('wish_item', '');
        that.updateItem(this.item);
        this.isToggleWishProcess = false;
      } else {
        app.wish.create({
          item_id: id,
        }, {
          wait: true,
          success: function (data) {
            that.item.set('wish_item', data.toJSON());
            that.updateItem(that.item);
            that.isToggleWishProcess = false;
          },
          error: function () {
            that.isToggleWishProcess = false;
          },
          method: 'POST',
        });
      }
    },
  });
})(jQuery);

}.call(window));